import React from 'react'
// import getConfig from 'next/config'
// const {
//   publicRuntimeConfig: { production = false },
// } = getConfig()
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTags } from '@fortawesome/free-solid-svg-icons/faTags'
import style from './style'

import { CategoryLink, AuthorLink, TopicLink } from '../../link'
import Heading from '../../heading'
import LinkArrow from 'components/link-arrow'
import AdGlare from 'components/adGlare'

import TOCTree from '../../toc-tree'

import { YCDate } from 'util/datetime'
import { RelatedOverview, RelatedLink } from '../../related'
import { useArticleExt } from 'store/article'

interface Props {
  id: string
}

export const Sidebar = ({ id }: Props): JSX.Element => {
  const { category, publicationDate, author, topics = [] } = useArticleExt(id)

  const topicsList = (
    <div className={style('sidebar-info')}>
      <FontAwesomeIcon icon={faTags} />
      <ul className={style('sidebar-topics')}>
        {topics.map(({ id }) => (
          <TopicLink
            id={id}
            key={id}
            WrapComponent="li"
            className={style('badge', 'badge-pill', 'badge-secondary')}
          />
        ))}
      </ul>
    </div>
  )

  const renderPublished = () =>
    publicationDate ? (
      <>
        {' | '}
        <YCDate date={publicationDate} />
      </>
    ) : (
      ''
    )

  const renderAuthor = () =>
    author ? (
      <>
        {' - '} By <AuthorLink id={author.id} analyticsAction="sidebar-link" />
      </>
    ) : (
      ''
    )

  return (
    <>
      <aside className={style('sidebar')}>
        <div className={style('ad')}>
          <AdGlare />
        </div>
        {topics.length > 0 && topicsList}
        <div className={style('sidebar-related')}>
          <Heading>Related Posts</Heading>
          <RelatedOverview data={id} />
          <RelatedLink analyticsAction="sidebar-link" id={id}>
            <LinkArrow className={style('related-link')}>More like this</LinkArrow>
          </RelatedLink>
        </div>
      </aside>
      <TOCTree topOffset={75} bottomOffset={75} id={id} className={style('sidebar-toc')}>
        <Heading>Table of Contents</Heading>
      </TOCTree>
    </>
  )
}

export default Sidebar
